import { IModificationsModalContext } from './modificationsModalContext';

export enum ModificationsModalActionTypes {
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_MODIFICATIONS_DISH_CATEGORY = 'SET_MODIFICATIONS_DISH_CATEGORY',
	SET_MODIFICATIONS_DISH_SUB_CATEGORY = 'SET_MODIFICATIONS_DISH_SUB_CATEGORY',
	SET_FETCHED_MODIFICATIONS_DISHES = 'SET_FETCHED_MODIFICATIONS_DISHES',
	SET_MODIFICATIONS_DISHES = 'SET_MODIFICATIONS_DISHES',
}

interface ISetAllData {
	type: ModificationsModalActionTypes.SET_ALL_DATA;
	payload: {
		dishInfo: IModificationsModalContext['dishInfo'];
		IDsSelectedRestaurant: IModificationsModalContext['IDsSelectedRestaurant'];
		fetchedModificationsDishes: IModificationsModalContext['fetchedModificationsDishes'];
		selectedModificationsDishes: IModificationsModalContext['selectedModificationsDishes'];
	};
}

interface ISetModificationsDishCategory {
	type: ModificationsModalActionTypes.SET_MODIFICATIONS_DISH_CATEGORY;
	payload: {
		selectedModificationsDishCategory: IModificationsModalContext['selectedModificationsDishCategory'];
	};
}

interface ISetModificationsDishSubCategory {
	type: ModificationsModalActionTypes.SET_MODIFICATIONS_DISH_SUB_CATEGORY;
	payload: {
		selectedModificationsDishSubCategory: IModificationsModalContext['selectedModificationsDishSubCategory'];
	};
}

interface ISetFetchedModificationsDishes {
	type: ModificationsModalActionTypes.SET_FETCHED_MODIFICATIONS_DISHES;
	payload: {
		fetchedModificationsDishes: IModificationsModalContext['fetchedModificationsDishes'];
	};
}

interface ISetModificationsDishes {
	type: ModificationsModalActionTypes.SET_MODIFICATIONS_DISHES;
	payload: {
		selectedModificationsDishes: IModificationsModalContext['selectedModificationsDishes'];
	};
}

export type TModificationsModalAction =
	| ISetAllData
	| ISetModificationsDishCategory
	| ISetModificationsDishSubCategory
	| ISetFetchedModificationsDishes
	| ISetModificationsDishes;
